import React, { useState } from 'react'
import './ChatGpt.css'
import RenderSvg from '../../components/renderSvg/RenderSvg';
const ChatGpt = () => {
    const [activeTab, setActiveTab] = useState('file');
    return (
        <div style={{height:"100%", overflow:"hidden"}}>
            <iframe src="http://cpg-gpt-staging.s3-website.ap-south-1.amazonaws.com/chat" title="chatGPT" height="100%" frameBorder="0" width="100%" ></iframe>
        </div>
        // <div className='chat_gpt'>
        //     <div className="chat_gpt_header">CPG-GPT</div>
        //     <div className="chat_gpt_upload_title">Upload file type</div>
        //     <div className="chat_gpt_file_types_container">
        //         <div className="chat_gpt_file_type" style={activeTab === "file" ? { borderBottom: "2px solid #d4d3d3", color: "black", padding: "2px" } : {}} onClick={() => setActiveTab('file')}>File</div>
        //         <div className="chat_gpt_file_type" style={activeTab === "text" ? { borderBottom: "2px solid #d4d3d3", color: "black", padding: "2px" } : {}} onClick={() => setActiveTab('text')}>Text</div>
        //         <div className="chat_gpt_file_type" style={activeTab === "website" ? { borderBottom: "2px solid #d4d3d3", color: "black", padding: "2px" } : {}} onClick={() => setActiveTab('website')}>Website</div>
        //     </div>

        //     <div className="chat_gpt_upload_container">

        //         {activeTab === "file" && <div className="chat_gpt_file_input_container">
        //             <input type="file" className='chat_gpt_file_input' />
        //         </div>}

        //         {activeTab === "text" && <div className="chat_gpt_text_input_container">
        //             <div className='chat_gpt_text_input_field'><input type="text" placeholder='chatbot name' /></div>
        //             <div className='chat_gpt_text_input_field'><textarea placeholder='data' name=""></textarea></div>
        //         </div>}


        //         {activeTab === "website" && <div className="chat_gpt_website_input_container">
        //             <div className="chat_gpt_website_upload_title">Crawl</div>
        //             <div className="chat_gpt_website_inputbox_container">
        //                 <input type="text" className='chat_gpt_website_input_field' placeholder='https://example.com' />
        //                 <button className='chat_gpt_website_upload_button'>Fetch Links</button>
        //             </div>
        //             <div className="chat_gpt_website_message">This will crawl all the links starting with the URL (not including files on the website) . Has to be server side rendered website</div>

        //             <div className="chat_gpt_website_divider_container">
        //                 <div className="chat_gpt_website_divider_line"> <hr /> </div>
        //                 <div>OR</div>
        //                 <div className="chat_gpt_website_divider_line"><hr /></div>
        //             </div>

        //             <div className="chat_gpt_website_upload_title">Submit Sitemap</div>
        //             <div className="chat_gpt_website_inputbox_container">
        //                 <input type="text" className='chat_gpt_website_input_field' placeholder='https://example.com/sitemap.xml' />
        //                 <button className='chat_gpt_website_upload_button'>Load Sitemap</button>
        //             </div>

        //             <div className='chat_gpt_website_addLinks_title'>Links to include</div>
        //             <div className='chat_gpt_website_addLinks_button'><button>Add</button></div>
        //         </div>}

        //         <div className='chat_gpt_update_button_container'>
        //             <button className='chat_gpt_update_button'>
        //                 <div>UPDATE</div>  <div className='chat_gpt_svg_container' ><RenderSvg name="chevron" /></div></button>
        //         </div>

        //         <div className="chat_gpt_upload_history_container">
        //             <button>Show Upload History </button>
        //         </div>
        //     </div>
        // </div>
    )
}

export default ChatGpt